import React from 'react';
import { Section } from './ui/Section';
import { trackEvent } from '../utils/metaPixel';
export function ValueCalculator() {
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section variant="alt" data-id="element-361">
      <div className="max-w-3xl mx-auto" data-id="element-362">
        <div className="bg-gradient-card border border-brand-borderGlow/30 rounded-2xl p-8 mb-10 text-center" data-id="element-363">
          <p className="text-xl md:text-2xl text-brand-subtitle font-bold leading-relaxed mb-6" data-id="element-364">
            La diferencia entre un instructor que llena salas y uno que
            improvisa no es el talento.
          </p>
          <p className="text-2xl md:text-3xl text-brand-gold font-bold mb-6" data-id="element-365">
            Es el sistema.
          </p>
          <p className="text-lg text-brand-text leading-relaxed mb-4" data-id="element-366">
            Hoy puedes tener ese sistema por menos de lo que cobras por una
            clase particular.
          </p>
          <p className="text-lg text-brand-text leading-relaxed mb-4" data-id="element-367">
            Mañana tus alumnos lo van a notar. La semana que viene van a empezar
            a recomendarte.
          </p>
          <p className="text-xl text-brand-subtitle font-bold" data-id="element-368">
            ¿O prefieres seguir improvisando?
          </p>
        </div>

        <div className="space-y-4 mb-6" data-id="element-369">
          <a href="https://digipromarket.com/cart/56520077934918:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Completo', '19.99')} className="font-heading w-full bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-gold-glow tracking-wide" data-id="element-370">
            🚀 QUIERO EL PACK COMPLETO — 19,99€
          </a>

          <a href="https://digipromarket.com/cart/56520042512710:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Base', '13.99')} className="font-heading w-full bg-gradient-card hover:bg-brand-card/80 border-2 border-brand-gold text-brand-gold font-bold text-lg md:text-xl py-4 px-8 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block tracking-wide" data-id="element-371">
            🥉 Empezar con el Pack Base — 13,99€
          </a>
        </div>

        <div className="text-center text-brand-text font-medium text-sm tracking-wide" data-id="element-372">
          ⚡ Acceso inmediato · 🛡️ Garantía 7 días · 💳 Pago único
        </div>
      </div>
    </Section>;
}